import {
  StyleSymbolType,
  ParameterValue,
  ClassifyAble,
  RasterSymbol,
  LabelType,
  isCompositeSymbol,
} from "../../../interfaces/style";
import { getParameterValue } from "./getFromClassified";

const PATH_SEPARATOR = ".";

export const symbolParameterWalker =
  (valueModifier: (parameterValue: ClassifyAble<ParameterValue>) => ClassifyAble<ParameterValue> | void) =>
  <S extends StyleSymbolType | LabelType>(symbol: S, path: string | string[]): S => {
    const paths = Array.isArray(path) ? path : path.split(PATH_SEPARATOR);
    const [firstKey, ...restKeys] = paths;

    if (!symbol) return null;

    const symbolPart = symbol[firstKey];

    if (isCompositeSymbol(symbol as RasterSymbol) && firstKey === "childSymbols") {
      return {
        ...symbol,
        [firstKey]: symbolPart.map(
          (childSymbol: StyleSymbolType) => symbolParameterWalker(valueModifier)(childSymbol, restKeys) || childSymbol,
        ),
      };
    }

    if (restKeys.length) {
      return {
        ...symbol,
        [firstKey]: symbolParameterWalker(valueModifier)(symbolPart, restKeys) || symbolPart,
      };
    }

    return {
      ...symbol,
      [firstKey]: valueModifier(symbolPart) || symbolPart,
    };
  };

export const setDefaultSymbolParameter = symbolParameterWalker(getParameterValue);

export const updateSymbolParameter = <S extends StyleSymbolType | LabelType>(
  symbol: S,
  path: string,
  value: ClassifyAble<ParameterValue>,
): S => symbolParameterWalker(() => value)(symbol, path);
